
    <ng-content *ngIf="!divider"></ng-content>